import React, { Component } from 'react';

import ZSelectField from '../../Utility/ZSelectField';

export default class ScopeSlide extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }

    }

    render() {

        let iconsJsx = [];
        let optionsJsx = [];
        let activeHit = false;
        let activeChoice = { menuItems: [] };
        this.props.choices.forEach((choice) => {
            let isActive = this.props.value === choice.value;

            let iconClass = "material-icons gc-scope-icon ";

            if (isActive) {
                activeHit = true;
                activeChoice = choice;
                iconClass += "gc-icon--active";
            } else if (!activeHit) {
                iconClass += "gc-scope-icon--left";
            } else {
                iconClass += "gc-scope-icon--right";
            }

            if (!choice.hasValue) {
                iconClass += " inactive";
            }

            let optionClass = "gc-cscope-button" + (isActive ? " gc-button--active" : "");

            iconsJsx.push((
                <div className={iconClass}>{choice.icon}</div>
            ));
            optionsJsx.push((
                <div className={optionClass} onClick={this.props.onSelect.bind(null, choice.value)}>{choice.displayText}</div>
            ));
        });

        let showSelectField = activeChoice.menuItems.length > 0;

        let lrPosition = this.props.position < this.props.slideNumber ? '-100vw' : this.props.position > this.props.slideNumber ? '100vw' : '0vw';

        let cardHeight = 17;
        this.props.choices.forEach((choice) => {
            cardHeight += 3;
        });
        if (showSelectField) {
            cardHeight += 7;
        }
        cardHeight = this.props.position === this.props.slideNumber ? cardHeight : 0;

        return (
            <div className={"gc-slide"} style={{ left: lrPosition, overflow: 'hidden', height: cardHeight + 'rem' }}>
                {iconsJsx}
                <div className="gc-question cscope">{this.props.question}</div>
                <div>{optionsJsx}</div>
                <div className={"gc-question clocation c" + this.props.choices.length + (!showSelectField ? ' hidden' : '')}>{this.props.question2}</div>
                <ZSelectField
                    id={"gc-location-select-field"}
                    placeholder={"Select " + this.props.value[0].toUpperCase() + this.props.value.substring(1)}
                    defaultValue={null}
                    className={"gc-z-selector clocation c" + this.props.choices.length + (!showSelectField ? ' hidden' : '')}
                    menuItems={activeChoice.menuItems}
                    onChange={this.props.onMenuSelect}
                    value={this.props.menuSelectValue}
                    activeColor={"rgba(0, 126, 181, 1)"}
                    isBlocked
                />
            </div>
        );
    }
}